import { USER_FIELD_ID_CERTIFICADO_CALIBRACAO } from './mappingIds'

/**
 * Certificado de Calibração do EXECUTOR da atividade (Seção 21) — Campo Adicional da
 * conta/usuário que executou o serviço (`serviceOrder.user`), NUNCA das respostas da
 * própria atividade. Requisito de Julia Buzzo (PM, 2026-08-27): o certificado de
 * calibração de um equipamento de terceiros não tem relação com quem respondeu o
 * checklist daquela atividade específica — e sim com o certificado que o técnico
 * executor tem cadastrado no seu próprio perfil (reaproveitável em várias atividades).
 *
 * `executorFieldValues` já vem mesclado (Campo Adicional direto do usuário + Campo
 * Adicional do "contract"/vínculo do usuário) por `ExecutorCertificadoLoader.js` — mesmo
 * merge usado pelo autofill de formulário de execução, a única outra leitura de Campo
 * Adicional de usuário hoje no front-end (ver `mergeUserFieldValues` em
 * `serviceOrders/executionV2/_requests/fetchAutofillValue.js`).
 *
 * Casado por ID do campo (`USER_FIELD_ID_CERTIFICADO_CALIBRACAO`, ver comentário em
 * `mappingIds.js`). Só sabe renderizar o tipo
 * "gallery" (upload de imagem/arquivo) — o mesmo tipo de Campo Adicional já usado em
 * outros lugares do app para anexar um documento/certificado escaneado (ver
 * `lmdasilva/general/CustomFields.js`, `fieldValue.field.type === 'gallery'`). Qualquer
 * ausência — sem executor, sem esse Campo Adicional configurado na conta, campo
 * configurado mas vazio, ou configurado com um tipo diferente de "gallery" — retorna
 * `null` sem lançar erro, para que a Seção 21 caia no placeholder existente em vez de
 * quebrar a geração do PDF.
 *
 * Comparação por `String(...)` dos dois lados, NUNCA `===` direto — mesma causa raiz já
 * corrigida em `getFieldValueById` (`pdfHelpers.js`, PR #740) para os Campos Adicionais de
 * Local/Ativo: o `ID` do GraphQL sempre serializa como STRING na resposta (é assim que a
 * spec do GraphQL define o scalar `ID`, em qualquer client — aqui `accountsClient`, não
 * `placesClient`), enquanto `USER_FIELD_ID_CERTIFICADO_CALIBRACAO` é um number literal em
 * `mappingIds.js`. Bug encontrado nesta auditoria (2026-09-01): esta função ainda usava
 * `fv?.field?.id === USER_FIELD_ID_CERTIFICADO_CALIBRACAO` (comparação estrita), então
 * NUNCA encontrava o campo com dados reais da API (`"7" === 7` é sempre `false`) — a Seção
 * 21 sempre caía no placeholder de "sem certificado", mesmo com o Campo Adicional
 * corretamente cadastrado no usuário executor. O fix de #740 só cobriu `getFieldValueById`;
 * esta função, que resolve o mesmo tipo de campo por um caminho totalmente separado (não
 * reaproveita `getFieldValueById` porque precisa do array de itens da galeria, não de um
 * texto normalizado), tinha a MESMA causa raiz sem ter sido corrigida.
 */
export const getExecutorCertificadoCalibracao = (executorFieldValues = []) => {
  const fieldValue = (executorFieldValues || []).find(
    fv => String(fv?.field?.id) === String(USER_FIELD_ID_CERTIFICADO_CALIBRACAO)
  )
  if (!fieldValue || fieldValue.field?.type !== 'gallery') return null

  const itens = Array.isArray(fieldValue.value) ? fieldValue.value : []
  const itensValidos = itens.filter(item => item && typeof item === 'object')

  return itensValidos.length ? itensValidos : null
}
